import { useParams } from "react-router-dom";
import useWorkflow from "../hooks/useWorkflow";
import WorkflowSourceFieldTable from "./WorkflowSourceFieldTable";
import { InformationCircleIcon } from "@heroicons/react/outline";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { postData } from "../backend";
import WorkflowSignatureConfig from "./WorkflowSignatureConfig";
import { WorkflowContext } from "../contexts";

function PopupSourceFieldTable() {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const { workflow, mutateWorkflow } = useWorkflow(id);

  const [updateFileState, setUpdateFileState] = useState<"INITIAL" | "UPDATING" | "UPDATED">("INITIAL");

  async function handleUpdateFile() {
    setUpdateFileState("UPDATING");

    // TODO: Capture erros?
    for (const document of workflow!.documents)
      await postData(`/microsoft/document-config/${document!.microsoftDocumentConfig!.id}/update-file/`);

    setUpdateFileState("UPDATED");
    setTimeout(() => setUpdateFileState("INITIAL"), 2000);
  }

  if (!workflow) {
    return (
      <div className="flex flex-col items-center justify-center h-screen w-screen">
        <img src="https://static.portant.co/portant-loading-blue.svg" className="w-24 h-24" alt="Loading Logo" />
      </div>
    );
  }

  return (
    <WorkflowContext.Provider value={{ workflow, mutateWorkflow, automationOptions: {}, updateAutomationOptions: () => { }, updateAutoCreate: () => { }, sourceSettingsPortalNode: null }}>
      <div className="flex flex-col items-center h-screen w-screen px-2 py-4 gap-4">
        <h1 className="font-gilroy font-semibold">{workflow.name}</h1>
        <div className="relative flex flex-col gap-2 p-2 text-sm border-2 border-dashed border-blue rounded">
          <div className="flex items-center font-gilroy font-semibold">
            <InformationCircleIcon className="w-4 h-4 mr-2" />{t("How To Use The Source Field Table Window")}
          </div>
          <div className="text-xs font-semibold">
            {t("Adjust the width of the other browser window containing the document to keep this source field table window visible")}
          </div>
        </div>
        <WorkflowSourceFieldTable workflow={workflow} mutateWorkflow={mutateWorkflow} />
        <WorkflowSignatureConfig document={workflow.documents[0]} hideHeader />

        <button className={`text-xs text-white hover:text-blue mt-auto mr-auto ${updateFileState === "UPDATED" ? "" : ""} w-full`} onClick={handleUpdateFile} disabled={updateFileState === "UPDATING"}>
          {updateFileState === "INITIAL" ? "Save" : (updateFileState === "UPDATING" ? "Saving..." : "Saved!")}
        </button>
      </div>
    </WorkflowContext.Provider>
  );
}

export default PopupSourceFieldTable;
